import React from "react";
import moment from "moment";
import logo from "../../../assets/images/asset-planet-background.png";
import insuranceIcon from "../../../assets/images/insurance.png";
import endingInsuranceIcon from "../../../assets/images/modules.png";
import highInsuranceIcon from "../../../assets/images/performance.png";

export const InsurancePDFReport = ({
  insuranceList,
  totalPremium,
  stats,
  chartImage,
  clientName,
}) => {
  const formatCurrency = (val) => {
    return (parseFloat(val) || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <div
      id="insurance-report-pdf"
      style={{
        padding: "60px 30px",
        backgroundColor: "#fff",
        width: "950px",
        margin: "0 auto",
        fontFamily: "'Inter', sans-serif",
        color: "#000",
        boxSizing: "border-box",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "30px",
          borderBottom: "2px solid #eee",
          paddingBottom: "20px",
        }}
      >
        <img src={logo} alt="Logo" style={{ height: "50px", objectFit: "contain" }} />
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: "14px", color: "#666", fontWeight: "600" }}>Report Generated</div>
          <div style={{ fontSize: "16px", fontWeight: "bold", color: "#1F3C88" }}>
            {moment().format("MMMM D, YYYY")}
          </div>
        </div>
      </div>

      <h1 style={{ fontSize: "32px", fontWeight: "800", marginBottom: "5px", color: "#1c1c1c", letterSpacing: "-1px" }}>
        Insurance Report
      </h1>
      <div style={{ fontSize: "16px", color: "#666", fontWeight: "600", marginBottom: "25px" }}>
        Client: <span style={{ color: "#1F3C88", fontWeight: "800" }}>{clientName || "N/A"}</span>
      </div>

      {/* Summary Tiles Section */}
      <div data-pdf-section style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "20px", marginBottom: "40px" }}>
        {/* Monthly Premium Tile */}
        <div style={{ backgroundColor: "#f8faff", padding: "20px", borderRadius: "16px", border: "1px solid #e1e8f5", textAlign: "center" }}>
          <img src={insuranceIcon} alt="Insurance" style={{ height: "40px", marginBottom: "10px" }} />
          <h3 style={{ fontSize: "14px", color: "#1F3C88", fontWeight: "700", margin: "0 0 10px 0" }}>Monthly Premium</h3>
          <div style={{ fontSize: "24px", fontWeight: "800", color: "#1a2a52" }}>
            ${formatCurrency(totalPremium)}
          </div>
        </div>

        {/* Policies Ending Soon Tile */}
        <div style={{ backgroundColor: "#fff9f0", padding: "20px", borderRadius: "16px", border: "1px solid #fee2b3", textAlign: "center" }}>
          <img src={endingInsuranceIcon} alt="Ending Soon" style={{ height: "40px", marginBottom: "10px" }} />
          <h3 style={{ fontSize: "14px", color: "#e67e22", fontWeight: "700", margin: "0 0 10px 0" }}>Policies Ending Soon</h3>
          <div style={{ textAlign: "left", fontSize: "12px" }}>
            {stats && stats.nearestPolicyEndDates && stats.nearestPolicyEndDates.length > 0 ? (
              stats.nearestPolicyEndDates.map((item, idx) => (
                <div key={idx} style={{ display: "flex", justifyContent: "space-between", marginBottom: "4px" }}>
                  <span style={{ color: "#666", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "120px" }}>{item.policy_name}</span>
                  <span style={{ fontWeight: "600" }}>{moment(item.policy_end_date).format("MMM DD, YYYY")}</span>
                </div>
              ))
            ) : (
              <div style={{ textAlign: "center", color: "#999" }}>None</div>
            )}
          </div>
        </div>

        {/* Highest Monthly Premium Tile */}
        <div style={{ backgroundColor: "#f0fdf4", padding: "20px", borderRadius: "16px", border: "1px solid #dcfce7", textAlign: "center" }}>
          <img src={highInsuranceIcon} alt="Highest Premium" style={{ height: "40px", marginBottom: "10px" }} />
          <h3 style={{ fontSize: "14px", color: "#166534", fontWeight: "700", margin: "0 0 10px 0" }}>Highest Premiums</h3>
          <div style={{ textAlign: "left", fontSize: "12px" }}>
            {stats && stats.topPremiums && stats.topPremiums.length > 0 ? (
              stats.topPremiums.map((item, idx) => (
                <div key={idx} style={{ display: "flex", justifyContent: "space-between", marginBottom: "4px" }}>
                  <span style={{ color: "#666", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "120px" }}>{item.policy_name}</span>
                  <span style={{ fontWeight: "600" }}>${formatCurrency(item.premium_value)}</span>
                </div>
              ))
            ) : (
              <div style={{ textAlign: "center", color: "#999" }}>None</div>
            )}
          </div>
        </div>
      </div>

      {/* Chart Section */}
      <div data-pdf-section style={{ marginBottom: "50px" }}>
        <h2 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "20px", color: "#1c1c1c", borderLeft: "5px solid #1F3C88", paddingLeft: "15px" }}>
          Monthly Premium Trends
        </h2>
        <div style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "12px", border: "1px solid #f0f0f0", textAlign: "center", minHeight: "300px" }}>
          {chartImage ? (
            <img src={chartImage} alt="Insurance Chart" style={{ maxWidth: "100%", height: "auto" }} />
          ) : (
            <div style={{ color: "#ccc", paddingTop: "120px", fontStyle: "italic" }}>No chart data available for this period</div>
          )}
        </div>
      </div>

      {/* Insurance Table */}
      <h2 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "20px", color: "#1c1c1c", borderLeft: "5px solid #2A3DA3", paddingLeft: "15px" }}>
        Insurance Policies Details
      </h2>
      <table data-pdf-section style={{ width: "100%", borderCollapse: "separate", borderSpacing: "0", marginBottom: "50px", borderRadius: "12px", overflow: "hidden", border: "1px solid #E0E0E0" }}>
        <thead>
          <tr style={{ backgroundColor: "#2A3DA3", color: "#fff" }}>
            <th style={{ padding: "12px 14px", textAlign: "left", fontSize: "12px" }}>Policy Name</th>
            <th style={{ padding: "12px 14px", textAlign: "left", fontSize: "12px" }}>Insurance Company</th>
            <th style={{ padding: "12px 14px", textAlign: "left", fontSize: "12px" }}>Policy Number</th>
            <th style={{ padding: "12px 14px", textAlign: "left", fontSize: "12px" }}>Start Date</th>
            <th style={{ padding: "12px 14px", textAlign: "left", fontSize: "12px" }}>End Date</th>
            <th style={{ padding: "12px 14px", textAlign: "right", fontSize: "12px" }}>Monthly Premium</th>
          </tr>
        </thead>
        <tbody>
          {insuranceList && insuranceList.length > 0 ? (
            insuranceList.map((item, index) => {
              const isAnnual = item["Annual / Monthly / One-Time"] === "Annual" || item["Annual or Monthly"] === "Annual";
              const monthlyPremium = isAnnual ? item.Premium / 12 : item.Premium;
              
              return (
                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#fff" : "#fcfcfc" }}>
                  <td style={{ padding: "12px 14px", borderTop: "1px solid #eee", fontSize: "12px" }}>{item["Policy Name (Person(s)/Property Insured)"] || "N/A"}</td>
                  <td style={{ padding: "12px 14px", borderTop: "1px solid #eee", fontSize: "12px" }}>{item["Insurance Company"] || "N/A"}</td>
                  <td style={{ padding: "12px 14px", borderTop: "1px solid #eee", fontSize: "12px" }}>{item["Policy Number"] || "N/A"}</td>
                  <td style={{ padding: "12px 14px", borderTop: "1px solid #eee", fontSize: "12px" }}>{item["Policy Start Date"] ? moment(item["Policy Start Date"]).format("MM/DD/YYYY") : "N/A"}</td>
                  <td style={{ padding: "12px 14px", borderTop: "1px solid #eee", fontSize: "12px" }}>{item["Policy End Date"] ? moment(item["Policy End Date"]).format("MM/DD/YYYY") : "N/A"}</td>
                  <td style={{ padding: "12px 14px", borderTop: "1px solid #eee", fontSize: "12px", fontWeight: "bold", textAlign: "right" }}>${formatCurrency(monthlyPremium)}</td>
                </tr>
              );
            })
          ) : (
            <tr><td colSpan="6" style={{ padding: "30px", textAlign: "center", color: "#999" }}>No insurance policies found</td></tr>
          )}
        </tbody>
      </table>

      {/* Footer */}
      <div
        data-pdf-section
        style={{
          fontSize: "11px",
          lineHeight: "1.6",
          color: "#666",
          marginTop: "40px",
          textAlign: "center",
          padding: "20px",
          borderTop: "1px solid #eee",
        }}
      >
        <strong>Confidential & Unaudited:</strong> This report is intended solely for the named recipient and is for informational purposes only. The data reflects information provided by the user and has not been audited by <strong>Asset Planet.</strong> Asset Planet makes no warranty regarding the data's accuracy or completeness and does not provide financial, legal, or tax advice through this report.
      </div>
    </div>
  );
};
